var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7666 7.72949C9.5566 7.72949 7.7666 9.51949 7.7666 11.7295C7.7666 13.9395 9.5566 15.7295 11.7666 15.7295C13.9766 15.7295 15.7666 13.9395 15.7666 11.7295C15.7666 9.51949 13.9766 7.72949 11.7666 7.72949ZM20.7066 10.7295C20.2466 6.55949 16.9366 3.24949 12.7666 2.78949V0.729492H10.7666V2.78949C6.5966 3.24949 3.2866 6.55949 2.8266 10.7295H0.766602V12.7295H2.8266C3.2866 16.8995 6.5966 20.2095 10.7666 20.6695V22.7295H12.7666V20.6695C16.9366 20.2095 20.2466 16.8995 20.7066 12.7295H22.7666V10.7295H20.7066ZM11.7666 18.7295C7.8966 18.7295 4.7666 15.5995 4.7666 11.7295C4.7666 7.85949 7.8966 4.72949 11.7666 4.72949C15.6366 4.72949 18.7666 7.85949 18.7666 11.7295C18.7666 15.5995 15.6366 18.7295 11.7666 18.7295Z",
    fill: "#008788"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.39e129722d2bc4b5c887d2768bd3e9db.svg";
export { ForwardRef as ReactComponent };